export default class ConsoleGroup {
    _isStarted = false;
    _logs = [];
    _logger;
    constructor(logger = console) {
        this._logger = logger;
    }
    subGroup(subGroup) {
        this.push('subGroup', subGroup);
    }
    groupStart(...args) {
        this.push('group', args);
        this._isStarted = true;
    }
    log(...args) {
        this.push('log', args);
    }
    info(...args) {
        this.push('info', args);
    }
    warn(...args) {
        this.push('warn', args);
    }
    error(...args) {
        this.push('error', args);
    }
    groupEnd() {
        if (this._isStarted) {
            this.push('groupEnd');
        }
    }
    push(type, values = []) {
        this._logs.push({ type, values });
    }
    print(collapsed = true) {
        this._logs.forEach(log => {
            let type = log.type;
            if (type === 'subGroup' && log.values instanceof ConsoleGroup) {
                const subGroup = log.values;
                subGroup.print(collapsed);
                return;
            }
            const messages = log.values;
            if (messages[0] && typeof messages[0] === 'string') {
                let i = 0;
                messages[0] = messages[0].replace(/<(model|property|cache|fetch|unresolved|missing|time|b)>(%[sfd])<[^>]+>/ig, function (match, type, mark) {
                    i++;
                    const value = messages[i];
                    if (value) {
                        let start, end;
                        switch (type.toLowerCase()) {
                            case 'model':
                                start = 'font-weight: bold; color: blue';
                                end = 'font-weight: normal; color: inherit';
                                break;
                            case 'property':
                                start = 'font-weight: bold; color: purple';
                                end = 'font-weight: normal; color: inherit';
                                break;
                            case 'cache':
                                start = 'display: inline-block; border-radius: 3px; margin-left: 8px; background: green; padding: 3px 5px; color: white';
                                end = 'display: inline; background: inherit; color: inherit';
                                break;
                            case 'fetch':
                                start = 'display: inline-block; border-radius: 3px; margin-left: 8px; background: darkkhaki; padding: 3px 5px; color: white';
                                end = 'display: inline; background: inherit; color: inherit';
                                break;
                            case 'unresolved':
                                start = 'display: inline-block; border-radius: 3px; margin-left: 8px; background: orange; padding: 3px 5px; color: white';
                                end = 'display: inline; background: inherit; color: inherit';
                                break;
                            case 'missing':
                                start = 'display: inline-block; border-radius: 3px; margin-left: 8px; background: indianred; padding: 3px 5px; color: white';
                                end = 'display: inline; background: inherit; color: inherit';
                                break;
                            case 'time':
                                if (typeof messages[i] === 'number') {
                                    messages[i] = '' + messages[i].toString() + ' ms';
                                    mark = '%s';
                                }
                                start = 'display: inline-block; border-radius: 3px; margin-left: 8px; background: lavender; padding: 3px 5px; color: darkslateblue';
                                end = 'display: inline; background: inherit; color: inherit';
                                break;
                            case 'b':
                                start = 'font-weight: bold';
                                end = 'font-weight: normal';
                                break;
                        }
                        messages.splice(i, 0, start);
                        messages.splice(i + 2, 0, end);
                        i += 2;
                        return '%c' + mark + '%c';
                    }
                    return mark;
                });
            }
            switch (type) {
                case 'subGroup':
                case 'group':
                    if (collapsed) {
                        type = 'groupCollapsed';
                    }
                case 'groupCollapsed':
                case 'log':
                case 'info':
                case 'warn':
                case 'error':
                    this._logger[type](...messages);
                    break;
                case 'groupEnd':
                    this._logger[type]();
                    break;
            }
        });
        this._logs = [];
    }
}
//# sourceMappingURL=ConsoleGroup.js.map